import { render, staticRenderFns } from "./table-question-settings.vue?vue&type=template&id=b958e4f8&scoped=true"
import script from "./table-question-settings.vue?vue&type=script&lang=js"
export * from "./table-question-settings.vue?vue&type=script&lang=js"
import style0 from "./table-question-settings.vue?vue&type=style&index=0&id=b958e4f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b958e4f8",
  null
  
)

export default component.exports